import { React, useContext } from "react";
import Slider from "react-slick";
import { Link, useLocation } from "react-router-dom";
import CustomArrows from "./CustomArrows";
import SingleProducts from "./SingleProduct";
import { AccountContext } from "../contexts/AccountContext";
import { path } from "../urls";
import { LazyLoadImage } from "react-lazy-load-image-component";
import SliderPlaceHolder from "../assets/images/singleProduct.png";
import SliderPlace from "../assets/images/product.png";
import { FaAngleRight } from "react-icons/fa";
function WidgetsLoopMobile({ widget }) {
  const [accountState] = useContext(AccountContext);
  const location = useLocation();
  const { pathname } = location;

  const types = {
    1: "product",
    2: "category",
    3: "manufacturer",
    4: "seller",
  };

  const source_type = (() => {
    if (pathname === "/") return "home";
    if (pathname.includes("c=")) return "category";
    if (pathname.includes("s=")) return "seller";
    if (pathname.includes("m=")) return "manufacturer";
    if (pathname.startsWith("/latest")) return "new_arrival";
    return "home";
  })();

  const source_type_id = (() => {
    const lastSegment = pathname.split("/").pop();

    if (!lastSegment) return "";

    if (lastSegment.includes("=")) {
      const [key, value] = lastSegment.split("=");
      if (["p", "s", "m", "c"].includes(key)) {
        return value;
      }
    }

    return lastSegment;
  })();

  const setting = {
    // dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: true,
    autoplay: true,
    autoplaySpeed: 4000,
  };

  const carousal = {
    infinite: false,
    speed: 1000,
    slidesToShow: 2,
    slidesToScroll: 1,
    lazyLoad: true,
  };

  const grid = {
    infinite: false,
    speed: 1000,
    slidesToShow: 2,
    slidesToScroll: 1,
    lazyLoad: true,

    prevArrow: <CustomArrows direction={"l"} type={"grid"} />,
    nextArrow: <CustomArrows direction={"r"} type={"grid"} />,
  };
  const productMobile = {
    dots: false,
    speed: 200,
    slidesToShow:
      widget?.type === "banner"
        ? widget?.display === "carousal"
          ? 2
          : widget.column_number - 0.5
        : 2,
    swipeToSlide: true,
    infinite: false,
    arrows: false,
    lazyLoad: true,
  };
  const productSetting = {
    dots: true,
    speed: 200,
    swipeToSlide: true,
    slidesToShow: 2,
    slidesToScroll: 4,
    infinite: true,
    prevArrow: <CustomArrows direction={"l"} />,
    nextArrow: <CustomArrows direction={"r"} />,
  };

  return (
    <div className="py-1">
      {widget.display === "slider" && (
        <Slider {...setting}>
          {widget?.items?.map((item, index) =>
            item.mobile_type < 4 ? (
              <Link
                to={
                  // accountState.admin
                  //   ? `${path}/${types[item.mobile_type]}/${item.mobile_type_id}`
                  //   :

                  item.name.length > 0
                    ? "/" +
                      item.name
                        .replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                        .replace(/\s+/g, "-")
                        .replace("/", "-")
                        .replace("%", "") +
                      "/" +
                      types[item.mobile_type].slice(0, 1) +
                      "=" +
                      item.mobile_type_id
                    : "cat/c=" + item.mobile_type_id
                }
                state={{
                  banner_id: item.banner_id,
                  banner_image_id: item.banner_image_id,
                  source_type: source_type,
                  source_type_id: source_type_id,
                }}
                key={index}
              >
                <LazyLoadImage
                  src={"https://www.englishhome.com.lb/image/" + item.image}
                  alt={item.name}
                  width={"590"}
                  height={"270"}
                  placeholderSrc={SliderPlaceHolder}
                />
              </Link>
            ) : (
              <a href={"https://englishhome.com.lb/app"}>
                <LazyLoadImage
                  src={"https://www.englishhome.com.lb/image/" + item.image}
                  alt={item.name}
                  width={"590"}
                  height={"270"}
                  placeholderSrc={SliderPlaceHolder}
                />
              </a>
            )
          )}
        </Slider>
      )}
      {/* view all button */}
      {widget?.display === "carousel" &&
        (widget.type !== "widget_recommended" ||
          (widget.type === "widget_recommended" &&
            widget.normal_carousel === true)) && (
          <div
            className={`flex items-center ${
              widget.view_title ? "justify-between" : "justify-end"
            }`}
          >
            {widget.view_title && (
              <h1
                className="pr-semibold p-2 text-xl"
                dangerouslySetInnerHTML={{ __html: widget.title }}
              />
            )}
            {widget.view_all !== "0" && (
              <div>
                {widget.type === "seller" ? (
                  <a
                    href={
                      widget.filters !== false && widget.filters !== ""
                        ? "/" +
                          widget.title
                            .replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                            .replace(/\s+/g, "-")
                            .replaceAll("/", "-")
                            .replace("%", "") +
                          "/s=" +
                          widget.type_id +
                          "?has_filter=true" +
                          (widget?.filters?.filter_categories
                            ? "&filter_categories=" +
                              widget?.filters?.filter_categories.map(
                                (fc) => fc.id
                              )
                            : "") +
                          (widget?.filters?.filter_manufacturers
                            ? "&filter_manufacturers=" +
                              widget?.filters?.filter_manufacturers.map(
                                (fm) => fm.id
                              )
                            : "") +
                          (widget?.filters?.filter_sellers
                            ? "&filter_sellers=" +
                              widget?.filters?.filter_sellers.map((fs) => fs.id)
                            : "") +
                          (widget?.filters?.filter_options
                            ? "&filter_options=" +
                              widget?.filters?.filter_options.map((fo) => fo.id)
                            : "")
                        : "/" +
                          widget.title
                            .replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                            .replace(/\s+/g, "-")
                            .replaceAll("/", "-")
                            .replace("%", "") +
                          "/s=" +
                          widget.type_id
                    }
                  >
                    <h1 className="font-bold text-xs px-2 py-1 cursor-pointer hover:opacity-80 flex items-center">
                      VIEW ALL <FaAngleRight className="mr-1 ml-1" />
                    </h1>
                  </a>
                ) : widget.type === "category" ? (
                  <a
                    href={
                      widget.filters !== false && widget.filters !== ""
                        ? "/" +
                          widget.title
                            .replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                            .replace(/\s+/g, "-")
                            .replaceAll("/", "-")
                            .replace("%", "") +
                          "/c=" +
                          widget.type_id +
                          "?has_filter=true" +
                          (widget?.filters?.filter_categories
                            ? "&filter_categories=" +
                              widget?.filters?.filter_categories.map(
                                (fc) => fc.id
                              )
                            : "") +
                          (widget?.filters?.filter_manufacturers
                            ? "&filter_manufacturers=" +
                              widget?.filters?.filter_categories.map(
                                (fm) => fm.id
                              )
                            : "") +
                          (widget?.filters?.filter_sellers
                            ? "&filter_sellers=" +
                              widget?.filters?.filter_sellers.map((fs) => fs.id)
                            : "") +
                          (widget?.filters?.filter_options
                            ? "&filter_options=" +
                              widget?.filters?.filter_options.map((fo) => fo.id)
                            : "")
                        : "/" +
                          widget.title
                            .replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                            .replace(/\s+/g, "-")
                            .replaceAll("/", "-")
                            .replace("%", "") +
                          "/c=" +
                          widget.type_id
                    }
                  >
                    <h1 className="font-bold text-xs px-2 py-1 cursor-pointer hover:opacity-80 flex items-center">
                      VIEW ALL <FaAngleRight className="mr-1 ml-1" />
                    </h1>
                  </a>
                ) : (
                  <a
                    href={
                      widget.type === "new_arrival"
                        ? "/latest"
                        : widget.filters !== false && widget.filters !== ""
                        ? "/" +
                          widget.title
                            .replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                            .replace(/\s+/g, "-")
                            .replaceAll("/", "-")
                            .replace("%", "") +
                          "/c=" +
                          widget.type_id +
                          "?has_filter=true" +
                          (widget?.filters?.filter_categories
                            ? "&filter_categories=" +
                              widget?.filters?.filter_categories.map(
                                (fc) => fc.id
                              )
                            : "") +
                          (widget?.filters?.filter_manufacturers
                            ? "&filter_manufacturers=" +
                              widget?.filters?.filter_manufacturers.map(
                                (fm) => fm.id
                              )
                            : "") +
                          (widget?.filters?.filter_sellers
                            ? "&filter_sellers=" +
                              widget?.filters?.filter_sellers.map((fs) => fs.id)
                            : "") +
                          (widget?.filters?.filter_options
                            ? "&filter_options=" +
                              widget?.filters?.filter_options.map((fo) => fo.id)
                            : "")
                        : "/" +
                          widget.title
                            .replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                            .replace(/\s+/g, "-")
                            .replaceAll("/", "-")
                            .replace("%", "") +
                          "/c=" +
                          widget.type_id
                    }
                  >
                    <h1 className="font-bold text-xs px-2 py-1 cursor-pointer hover:opacity-80 flex items-center">
                      VIEW ALL <FaAngleRight className="mr-1 ml-1" />
                    </h1>
                  </a>
                )}
              </div>
            )}
          </div>
        )}
      {widget.display === "carousel" &&
        (widget.type === "widget_recommended" &&
        widget.items.length > 0 &&
        widget.items[0].items.length > 0 ? (
          <div
            style={{
              backgroundImage: `linear-gradient(
            ${widget.items[0].background_color_secondary},
            ${widget.items[0].background_color_primary})`,
            }}
            className="mx-2"
          >
            <div className="px-1 flex flex-col items-start">
              <div className="flex justify-between  w-full">
                <h1
                  className={`text-lg font-black`}
                  style={{ color: widget.items[0].font_color }}
                >
                  {widget.items[0].title}
                </h1>
                <Link
                  to={
                    widget.items[0]?.type === "recommended"
                      ? `/${widget.items[0].type}/${widget.items[0].type_id}`
                      : "cat/c=" + widget.items[0].type_id
                  }
                >
                  <span className="cursor-pointer ml-4 text-md mt-1">
                    View More &gt;
                  </span>
                </Link>
              </div>

              <p className="mb-1 text-sm">{widget.items[0].description}</p>
            </div>

            <div
              style={{
                overflowX: "auto",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
              className="flex gap-2.5 p-2"
            >
              {widget.items[0].items.map((item, index) => (
                <div
                  key={index}
                  className="w-[20vw] flex flex-col items-start justify-center shrink-0"
                >
                  <Link to={`/product/${item.product_id}`}>
                    <img
                      src={item.thumb}
                      alt=""
                      className="w-full object-contain"
                    />
                  </Link>
                  <h1 className="mt-1">{item.price}</h1>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="">
            {window.innerWidth > 650 ? (
              <Slider {...productSetting} className="carousel">
                {widget.items?.map((item) => {
                  if (item.product_id) {
                    return (
                      <div
                        className=" grid grid-flow-col  p-3"
                        key={item.product_id}
                      >
                        <SingleProducts
                          className=""
                          // likedData={likedData}
                          item={item}
                          // click={handleOnItemClick}
                          // dragging={dragging}
                        ></SingleProducts>
                      </div>
                    );
                  } else {
                    return (
                      <div
                        className={`p-2 cursor-pointer hover:opacity-80 w-1/${widget.column_number} md:w-1/${widget.column_number}`}
                        key={item.banner_image_id}
                      >
                        <Link
                          to={`${
                            // accountState.admin
                            //   ? path +
                            //     "/" +
                            //     types[item.mobile_type] +
                            //     "/" +
                            //     item.mobile_type_id
                            //   :

                            item.name.length > 0
                              ? "/" +
                                item.name
                                  .replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                                  .replace(/\s+/g, "-")
                                  .replace("/", "-")
                                  .replace("/", "-") +
                                "/" +
                                types[item.mobile_type].slice(0, 1) +
                                "=" +
                                item.mobile_type_id
                              : "cat/c=" + item.mobile_type_id
                          }`}
                          state={{
                            banner_id: item.banner_id,
                            banner_image_id: item.banner_image_id,
                            source_type: source_type,
                            source_type_id: source_type_id,
                          }}
                        >
                          <LazyLoadImage
                            alt={item.name}
                            src={
                              `${window.config["site-url"]}/image/` + item.image
                            }
                            // width={widget.banner_width}
                            height={widget.banner_height}
                            title={item.name}
                            placeholdersrc={SliderPlace}
                          />
                        </Link>
                      </div>
                    );
                  }
                })}
              </Slider>
            ) : (
              <Slider {...productMobile}>
                {widget.items?.map((item) => {
                  if (item.product_id) {
                    return (
                      <div className="pr-3" key={item.product_id}>
                        <SingleProducts
                          // likedData={likedData}
                          item={item}
                        ></SingleProducts>
                      </div>
                    );
                  } else {
                    return (
                      <div className={`pr-2`} key={item.banner_image_id}>
                        <Link
                          to={`${
                            // accountState.admin
                            //   ? path +
                            //     "/" +
                            //     types[item.mobile_type] +
                            //     "/" +
                            //     item.mobile_type_id
                            //   :
                            item.name.length > 0
                              ? "/" +
                                item.name
                                  .replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                                  .replace(/\s+/g, "-")
                                  .replace("/", "-")
                                  .replace("/", "-") +
                                "/" +
                                types[item.mobile_type].slice(0, 1) +
                                "=" +
                                item.mobile_type_id
                              : "cat/c=" + item.mobile_type_id
                          }`}
                          state={{
                            banner_id: item.banner_id,
                            banner_image_id: item.banner_image_id,
                            source_type: source_type,
                            source_type_id: source_type_id,
                          }}
                        >
                          <LazyLoadImage
                            alt={item.name}
                            src={
                              `https://www.englishhome.com.lb/image/` +
                              item.image
                            }
                            width={item.banner_width}
                            height={item.banner_height}
                            title={item.name}
                          />
                        </Link>
                      </div>
                    );
                  }
                })}
              </Slider>
            )}
          </div>
        ))}

      {widget.display === "grid" &&
        widget.items.length > 1 &&
        (widget.type === "widget_recommended" ? (
          <div className="flex gap-2 mx-2">
            {widget.items[0] && (
              <Link
                to={
                  widget.items[0]?.type === "recommended"
                    ? `/${widget.items[0].type}/${widget.items[0].type_id}`
                    : "cat/c=" + widget.items[0].type_id
                }
              >
                <div
                  style={{
                    backgroundImage: `linear-gradient(
                    150deg, 
                    ${widget.items[0].background_color_secondary},
                    ${widget.items[0].background_color_primary})`,
                  }}
                  className="rounded text-start"
                >
                  <div className="px-2">
                    <div className="flex justify-between w-full">
                      <h2
                        style={{
                          color: widget.items[0].font_color,
                          fontWeight: "900",
                        }}
                        className="text-[0.71rem] lg:text-lg"
                      >
                        {widget.items[0].title}
                      </h2>
                      <span className="cursor-pointer ml-4 text-[0.60rem] mb-1 mr-1 lg:text-lg">
                        {" "}
                        &gt;
                      </span>
                    </div>
                    <p className="mb-1 lg:text-sm" style={{ fontSize: "10px" }}>
                      {widget.items[0].description}
                    </p>
                  </div>

                  <div className="flex gap-2 px-2">
                    {widget.items[0].items?.slice(0, 2).map((item) => (
                      <div key={item.product_id}>
                        <img src={item.thumb} alt="" />
                        <span className="lg:text-lg">{item.special}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </Link>
            )}
            {widget.items[1] && (
              <Link
                to={
                  widget.items[1]?.type === "recommended"
                    ? `/${widget.items[1].type}/${widget.items[1].type_id}`
                    : "cat/c=" + widget.items[1].type_id
                }
              >
                <div
                  style={{
                    backgroundImage: `linear-gradient(
                    150deg, 
                    ${widget.items[1].background_color_secondary},
                    ${widget.items[1].background_color_primary})`,
                  }}
                  className="rounded text-start"
                >
                  <div className="px-2">
                    <div className="flex justify-between w-full">
                      <h2
                        style={{
                          color: widget.items[1].font_color,
                          fontWeight: "900",
                        }}
                        className="text-[0.7rem] lg:text-lg"
                      >
                        {widget.items[1].title}
                      </h2>
                      <span className="cursor-pointer ml-4 text-[0.60rem] mb-1 mr-1 lg:text-lg">
                        {" "}
                        &gt;
                      </span>
                    </div>
                    <p className="mb-1 lg:text-sm" style={{ fontSize: "10px" }}>
                      {widget.items[1].description}
                    </p>
                  </div>
                  <div className="flex gap-2 px-2">
                    {widget.items[1].items?.slice(0, 2).map((item) => (
                      <div key={item.product_id}>
                        <img src={item.thumb} />
                        <span className="lg:text-lg">{item.special}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </Link>
            )}
          </div>
        ) : (
          <div
            className="px-1 grid gap-2"
            style={{
              gridTemplateColumns: `repeat(${widget.column_number}, minmax(0, 1fr))`,
            }}
          >
            {widget.mobile_widget_id > 0 ? (
              widget?.items?.map((item, index) =>
                item.mobile_type_id !== "0" ? (
                  <Link
                    to={
                      // accountState.admin
                      //   ? `${path}/${types[item.mobile_type]}/${
                      //       item?.mobile_type_id
                      //     }`
                      //   :

                      item?.name?.length > 0
                        ? "/" +
                          item?.name
                            ?.replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                            .replace("%", "")
                            .replace(/\s+/g, "-")
                            .replace("/", "-") +
                          "/" +
                          types[item.mobile_type]?.slice(0, 1) +
                          "=" +
                          item.mobile_type_id
                        : "cat/c=" + item.mobile_type_id
                    }
                    state={{
                      banner_id: item.banner_id,
                      banner_image_id: item.banner_image_id,
                      source_type: source_type,
                      source_type_id: source_type_id,
                    }}
                  >
                      <div className="relative flex flex-col items-center">
                    <LazyLoadImage
                      className="w-full"
                      alt={item.name}
                      src={`https://www.englishhome.com.lb/image/${item.image}`}
                      width={item.banner_width}
                      height={item.banner_height}
                    />
                      <h1
                      className="text-center text-[7px] pr-semibold"
                      dangerouslySetInnerHTML={{ __html: item?.title }}
                    />
                    </div>
                  </Link>
                ) : (
                  <div key={index} className="p-1">
                     <div className="relative flex flex-col items-center">
                    <LazyLoadImage
                      className="w-full"
                      alt={item.name}
                      src={`https://www.englishhome.com.lb/image/${item.image}`}
                    />
                      <h1
                      className="text-center text-[7px] pr-semibold"
                      dangerouslySetInnerHTML={{ __html: item?.title }}
                    />
                    </div>
                  </div>
                )
              )
            ) : (
              <div className="grid justify-between grid-cols-2">
                {widget?.items?.map((item, index) => (
                  <div key={index} className="p-1">
                    <LazyLoadImage
                      className="w-full"
                      src={"https://www.englishhome.com.lb/image/" + item.image}
                      alt={item.name}
                      // height={item.banner_height}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}

      {widget.display === "grid" &&
        widget.items.length < 2 &&
        widget?.items?.map((item, index) =>
          item.mobile_type_id !== "0" ? (
            <Link
              to={
                // accountState.admin
                //   ? `${path}/${types[item.mobile_type]}/${item?.mobile_type_id}`
                //   :
                item?.name?.length > 0
                  ? "/" +
                    item?.name
                      ?.replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                      .replace("%", "")
                      .replace(/\s+/g, "-")
                      .replace("/", "-") +
                    "/" +
                    types[item.mobile_type]?.slice(0, 1) +
                    "=" +
                    item.mobile_type_id
                  : "cat/c=" + item.mobile_type_id
              }
              state={{
                banner_id: item.banner_id,
                banner_image_id: item.banner_image_id,
                source_type: source_type,
                source_type_id: source_type_id,
              }}
            >
              <LazyLoadImage
                className="w-full"
                alt={item.name}
                src={`https://www.englishhome.com.lb/image/` + item.image}
                width={item.banner_width}
                height={item.banner_height}
                title={item.name}
              />
            </Link>
          ) : (
            <div key={index} className="p-1">
              <a
                href={`https://${item.link}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <LazyLoadImage
                  className="w-full"
                  src={"https://www.englishhome.com.lb/image/" + item.image}
                  alt={item.name}
                  height={item.banner_height}
                />
              </a>
            </div>
          )
        )}
    </div>
  );
}

export default WidgetsLoopMobile;
